import Reset24hFileModal from "./Reset24hFileModal";
import {Button, Modal, Spinner} from "@tag/tag-components-react-v4";
import {CustomerDTO} from "../types/CustomerDTO";
import React, {useEffect, useState} from "react";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";
import styles from './CustomerInfoModal.module.scss'
import AcpIntegrationDetails from "./AcpIntegrationDetails";
import AcpSettingsService from "../services/AcpSettingsService";
import {AcpSettingsDTO} from "../types/AcpSettingsDTO";
import WorkspaceDetails from "./WorkspaceDetails";
import DbSizesModal from "./DbSizesModal";
import CareConnectConfigurationDetails from "./CareConnectConfigurationDetails";
import { ProjectAccents } from "../../General/config/projectAccents";


function CustomerInfoModal(props: {selectedCustomer: CustomerDTO, handleClose: Function}) {

    const [loading, setLoading] = useState<string|boolean>(false)
    const [acpIntegrationDetailsVisible, setAcpIntegrationDetailsVisible] = useState(false);
    const [workspaceDetailsVisible, setWorkspaceDetailsVisible] = useState(false);
    const [dbSizesVisible, setDbSizesVisible] = useState(false);
    const [careConnectConfigurationVisible, setCareConnectConfigurationVisible] = useState(false);
    
    const { accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    
    let content;
    if (loading) {
        content = <Spinner full={true} >{loading}</Spinner>;
    }
    else {
        content = <>
            <Modal
                visible={!!props.selectedCustomer}
                accent={ProjectAccents.PeoplePlanner}
                heading={props.selectedCustomer?.name + ' - (' + props.selectedCustomer?.clientId + ')'}
                primaryButtonProps={{buttonStyle: {'display': 'none'}}}
                onCancelButtonClick={() => {
                    props.handleClose();
                }}
                onClose={() => props.handleClose()}
            >
                <div className={styles.CustomerInfoModalButtonContainer}>
                    <div className={styles.CustomerInfoModalButtonElement}>
                        <Button text={'ACP Integration Details'} onClick={() => setAcpIntegrationDetailsVisible(true)} />
                    </div>
                    <div className={styles.CustomerInfoModalButtonElement}>
                        <Button text={'Workspace Details'} onClick={() => setWorkspaceDetailsVisible(true)} />
                    </div>
                    <div className={styles.CustomerInfoModalButtonElement}>
                        <Button text={'DB Sizes'} onClick={() => setDbSizesVisible(true)} />
                    </div>
                    <div className={styles.CustomerInfoModalButtonElement}>
                        <Button text={'Care Connect Configuration'} onClick={() => setCareConnectConfigurationVisible(true)} />
                    </div>
                </div>
            </Modal>
        </>
    }

    return (
        <>
            {content}
            {acpIntegrationDetailsVisible ?
                <AcpIntegrationDetails
                    visible={acpIntegrationDetailsVisible}
                    selectedCustomer={props.selectedCustomer}
                    handleClose={() => setAcpIntegrationDetailsVisible(false)}
                    setLoading={setLoading}
                /> : undefined
            }
            {workspaceDetailsVisible ?
                <WorkspaceDetails
                    visible={workspaceDetailsVisible}
                    selectedCustomer={props.selectedCustomer}
                    handleClose={() => setWorkspaceDetailsVisible(false)}
                /> : undefined
            }
            {dbSizesVisible ?
                <DbSizesModal
                    visible={dbSizesVisible}
                    selectedCustomer={props.selectedCustomer}
                    handleClose={() => setDbSizesVisible(false)}
                /> : undefined
            }
            {careConnectConfigurationVisible ?
                <CareConnectConfigurationDetails
                    visible={careConnectConfigurationVisible}
                    selectedCustomer={props.selectedCustomer}
                    handleClose={() => setCareConnectConfigurationVisible(false)}
                /> : undefined
            }
        </>
    )

}

export default CustomerInfoModal;
